<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
    <van-nav-bar
      title="个人中心"
      id="topbar"
      style="background-color: #4263EB"
    >
      <template #right>
        <div style="border: 0px solid;line-height: 50px">
          <van-icon name="chat-o" :badge="notReadMessageCount" v-if="notReadMessageCount!==0" size="25" @click="$router.push({name:'common-messageList'})" />
          <van-icon name="chat-o" v-else size="25" @click="$router.push({name:'common-messageList',params:{backPath:'common-reviewMe'}})" />
        </div>
      </template>
    </van-nav-bar>

    <van-notice-bar  left-icon="volume-o" style="position: fixed;width: 100%;z-index: 9999" scrollable :text="messageText" v-if="notReadMessageCount!==0" />

    <!--      <div class="infoBox">
            <div class="infoWarp"  >
              <div class="infoLeft">
                <img v-if="!userInfo.avatar" class="heardImg" src="@/assets/headImg.png" alt="">
                <img v-if="userInfo.avatar" class="heardImg" :src="baseApi+userInfo.avatar" alt="">
                <div>
                  <div class="infoName"><span>{{userInfo.nname}}</span><span style="font-size: 12px;margin-left: 10px">{{userInfo.mobile}}</span></div>
                  <div class="infoPhone"><span>{{userInfo.roleName}}</span><span style="margin-left: 20px">测试项目</span></div>
                </div>
              </div>
            </div>
          </div>-->

    <div class="head-content">

      <div class="head-item">

        <div class="head-avatar">
          <img v-if="!userInfo.avatar" class="heardImg" src="@/assets/headImg.png" alt="">
          <img v-if="userInfo.avatar" class="heardImg" :src="baseApi+userInfo.avatar" alt="">
        </div>
        <div class="head-user-info">
          <p style="color: white;font-weight: bold;font-size: 18px;margin-top: 20px">
            {{userInfo.nname}}
          </p>
          <p style="color: #e1e1e1;margin-top: 10px">
            {{userInfo.mobile}}
          </p>
        </div>

      </div>
      <div class="head-item">

        <div class="head-item-li1">
          {{userInfo.roleName}}
        </div>
        <div class="head-item-li1" v-if="projectInfo.groupName">
          {{projectInfo.projectName}}({{projectInfo.groupName}})
        </div>

      </div>

    </div>

    <br>
    <div class="infoDiv" @click="toUserInfo">
      <van-row type="flex" justify="space-between" align="center">
        <van-col style="display:flex;align-items:center;">
          <div class="infoText">
            <div style="float: left"><van-icon color="#4263EB" name="description" size="20" /></div>
            <div style="float: left;font-weight: bold;line-height: 22px">用户资料</div>
          </div>
        </van-col>
        <van-col>
          <van-icon name="arrow" size="20" />
        </van-col>
      </van-row>
    </div>
    <!--      <div class="infoDiv" @click="createshow = true">-->
    <!--        <van-row type="flex" justify="space-between" align="center">&lt;!&ndash;-->
    <!--          <van-col style="display:flex;align-items:center;">-->
    <!--            <div class="infoText">-->
    <!--              <div>修改密码</div>-->
    <!--            </div>-->
    <!--          </van-col>&ndash;&gt;-->
    <!--          <van-col>-->
    <!--            <img class="rightIcon" src="../../assets/right.png">-->
    <!--          </van-col>-->
    <!--        </van-row>-->
    <!--      </div>-->
    <div class="infoDiv2" @click="toLogout">
      <div>退出登录</div>
    </div>

    <van-action-sheet v-model="createshow" title="密码修改">
      <div class="content">
        <van-form @submit="onCreateSubmit">
          <van-field
            v-model="oldpasswd"
            name="旧密码"
            label="旧密码"
            type="password"
            placeholder="请输入旧密码"
            :rules="[{ required: true, message: '此项必填' }]"
          />
          <van-field
            v-model="newpasswd"
            name="新密码"
            label="新密码"
            type="password"
            placeholder="请输入新密码"
            :rules="[{ required: true, message: '此项必填' }]"
          />
          <van-field
            v-model="newpasswd2"
            name="新密码"
            label="新密码"
            type="password"
            placeholder="请输入新密码"
            :rules="[{ required: true, message: '此项必填' }]"
          />
          <div style="margin: 32px 16px 16px 16px;">
            <van-button round block type="info" native-type="submit">
              保存
            </van-button>
          </div>
        </van-form>
      </div>
    </van-action-sheet>
    <van-tabbar v-model="active">
      <van-tabbar-item to="../reviewRecord">
        <span>待审核记录</span>
        <template #icon="props">
          <img :src="props.active ? icon.homeInActive : icon.homeActive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="../record">
        <span>历史审核记录</span>
        <template #icon="props">
          <img :src="props.active ? icon.featureInActive : icon.featureActive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="../common/reviewMe">
        <span>我的信息</span>
        <template #icon="props">
          <img :src="props.active ? icon.meInActive : icon.meActive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import $ from '@/fly'
import { Toast, Dialog, ImagePreview } from 'vant';
import Setting from '@/setting';
import {recMsg} from "@/api/module/message/message";
export default {
  name: 'common-me',
  props: {
    index: {
      type: Number,
      default () {
        return 0;
      }
    }
  },
  created () {
  },
  data () {
    return {
      baseApi:Setting.apiBaseURL+'/download/',
      icon: {
        homeInActive: require('../../assets/inHomeIcon.svg'),
        homeActive: require('../../assets/homeIcon.svg'),
        meInActive: require('../../assets/inMeIcon.svg'),
        meActive: require('../../assets/meIcon.svg'),
        featureActive: require('../../assets/proIcon.svg'),
        featureInActive: require('../../assets/inProIcon.svg')
      },
      active: 2,
      clientHeight: window.screen.height,
      createshow: false,
      newpasswd: '',
      newpasswd2: '',
      oldpasswd: '',
      userInfo:{},
      projectInfo:{},
      notReadMessageCount:0,
      messageText:''
    }
  },
  computed: {
  },
  mounted() {

    this.userInfo = JSON.parse(localStorage.getItem('USER'))
    console.log('userInfo',this.userInfo)
    this.projectInfo = JSON.parse(localStorage.getItem('projectInfo'))
    this.getMessageList()

  },
  methods: {
    //查询未读消息
    getMessageList(){
      recMsg(this.userInfo.userId,1,false).then(res=>{
        this.notReadMessageCount = res.total
        if(this.notReadMessageCount!==0){
          this.messageText = this.formatTimestamp(res.rows[0].sendTime)+'：'+res.rows[0].content
        }
      })
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    onCreateSubmit () {
      if (this.oldpasswd && this.newpasswd && this.newpasswd2) {
        if (this.newpasswd !== this.newpasswd2) {
          Toast('二次密码输入不一致')
        } else {
          var that = this;
          $.put('user/password', {
            originalPassword: this.oldpasswd,
            mobile: this.$store.state.admin.user.info.mobile,
            newPassword: this.newpasswd
          })
            .then(res => {
              if (res === 0) {
                Toast.fail('修改失败，当前密码输入错误');
              } else {
                Toast.success('修改成功,请重新登录');
                that.createshow = false;

                setTimeout(function () {
                  that.logout();
                }, 1500);
              }
              that.oldpasswd = ''
              that.newpasswd = ''
              that.newpasswd2 = ''
            });
        }
      } else {
        Toast('请填写完整信息')
      }
    },
    toUserInfo () {
      this.$router.push({ name: 'common-userInfoRe' });
    },
    logout () {
      // 删除cookie
      localStorage.removeItem('token');
      localStorage.removeItem('uuid');
      localStorage.removeItem('USER');
      localStorage.removeItem('USER_ROUTER');
      localStorage.removeItem('USER_PERMISSIONS');
      this.$router.push('/login');
    },
    toLogout () {
      Dialog.confirm({
        title: '是否退出登录'
      }).then(() => {
        this.logout();
      })
    }
  }
}

</script>
<style lang="less" scoped>


.head-content{
  width: 90%;
  height: 300px;
  margin: 0px auto;
  border-radius: 20px;
  background: linear-gradient(-73.41deg, #2969FF 0%, #A6B7FF 100%);
  margin-top: 30px;
}

.head-item{
  height: 50%;
  width: 100%;
}

.head-avatar{
  height: 100%;
  width: 30%;
  float:left;
  text-align: center;
  line-height: 170px;
}

.head-user-info{
  height: 100%;
  width: 70%;
  float: left;
  text-align: left;
}


.head-item-li1{
  width: 40%;
  height: 50%;
  float: left;
  margin-left: 6.5%;
  margin-top: 5%;
  border-radius: 6px;
  background: #FFFFFF14;
  backdrop-filter: blur(4px);
  box-shadow: ;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  line-height: 70px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;


}


.infoBox{
  width: 90%;
  height: 300px;
  background: #4188F2;
  border-radius: 50px 50px 50px 50px;
  padding: 30px 80px;
  margin: 0px auto;
  margin-top: 20px;
}
.infoWarp{
  width: 100%;
  /*border: 1px solid red;*/
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}
.infoLeft{
  display: flex;
  align-items: center;
}
.heardImg{
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-right: 20px;
}
.infoName{
  width: 350px;
  font-size: 32px;
  line-height: 76px;
  overflow: hidden;
}
.infoPhone{
  overflow: hidden;
  width: 400px;
  font-size: 26px;
  color: #FFFFFF;
  line-height: 76px;
}
.topBg{
  height:500px;
  width: 100%;
  background: url(../../assets/meBg.png) no-repeat;
  background-size: 100%;
}
.headImgDiv{
  line-height: 400px;
  text-align: center;
}
.headImg{
  width: 240px;
  height: 240px;
  border-radius: 50%;
  border:15px solid #3359fa;
}
.infoDiv{
  background-color: #FFFFFF;
  width: 100%;
  padding: 30px;
  margin-bottom: 25px;
  border-radius: 5px;
}
.rightIcon{
  width: 25px;
}
.infoDiv2{
  background-color: #FFFFFF;
  width: 100%;
  padding: 38px;
  margin-bottom: 25px;
  border-radius: 5px;
  text-align: center;
  color: #F65B5B;
  font-weight: bold;
  font-size: 28px;
}
</style>
